import { eventCodeOptions } from 'features/Weather/features/WeatherAlerts/features/AlertCreator/components/IpawsAlertFields/config/Ipaws.config';
import { nwsAlertTypes } from './nwsAlertTypes.config';

const addSourceToOptions = (sourceId, options) =>
  options.map(({ label, value, ...option }) => ({
    ...option,
    label,
    value: `${sourceId}:${value}`,
    sourceId,
    typeValue: value,
  }));

const nwsOptions = nwsAlertTypes.map((label) => ({ label, value: label }));

export const alertTypeGroups = [
  {
    sourceId: 'nws',
    label: 'NWS',
    options: addSourceToOptions('nws', nwsOptions),
  },
  {
    sourceId: 'fema',
    label: 'FEMA IPAWS',
    options: addSourceToOptions('fema', eventCodeOptions),
  },
  {
    sourceId: 'fusion',
    label: 'Overwatch Fusion +',
    options: addSourceToOptions('fusion', nwsOptions),
  },
];
